/**
 * External Dependencies
 */
import 'jquery';
import 'flickity/dist/flickity.pkgd';
import 'flickity-fade';
import 'masonry-layout/dist/masonry.pkgd';
import 'imagesloaded/imagesloaded.pkgd';
require('flickity-imagesloaded');

$(function () {
  $('.galeria').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true,
    fade: true,
    adaptiveHeight: true,
    imagesLoaded: true,
  });

  var $h = window.innerHeight;
  var $w = window.innerWidth;
  var $cell = $('.apaga')
  var $cell_p = $('.muestra')
  if($w > 768) {


    $('.galeria').flickity('remove', $cell)
  }
  if ($w < 768) {

    $('.galeria').flickity('insert', $cell, 1)
    $('.galeria').flickity('remove', $cell_p)
    $('.galeria').flickity('reloadCells')
  }
  // var $v = document.getElementById('gallery-video');
  $(window).on('resize', function(){
    //var $h = window.innerHeight;

    $('#gallery-video').css('height', $h + 'px');
    $('.flickity-viewport').css('height', $h + 'px');
  })

  var $grid = $('#msry');
  if($grid) {
    // init Masonry
    $grid.masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.grid-item',
      // use element for option
      columnWidth: '.size-item',
      percentPosition: true,
    });
    // layout Masonry after each image loads
    $grid.imagesLoaded().progress(function (instance, image) {
      if(image.img.width === 1) {
        image.img.style.width = 'auto'
      }
      image.img.classList.remove('opacity-0');
      $grid.masonry('layout');
    });
  }

  function moveBox() {
    $(targetedBox).bind('mousemove', function (event) {//Executes when the mouse MOVES
      adjustX = $(this).find(".popup").outerWidth(true);//gets the width of the targeted popup
      adjustY = $(this).find(".popup").outerHeight(true);//gets the height of the targeted popup
      // if (targetedBox == "#box1") {//example of moving popup relative to mouse
      //   adjustX = $(this).find(".popup").outerWidth(true) - 12;//creates a more unique value
      //   adjustY = $(this).find(".popup").outerHeight(true) - 12;
      // }
      //event.pageY or evet.pageX = the mouse position relative to the top left of the targeted box
      var my = event.pageY - $(this).offset().top - adjustY;//my = mouse y position with some adjustment relateive to top of box
      var mx = event.pageX - $(this).offset().left - adjustX; //mx = mouse x position with some adjustment relateive to left of box
      var mr = event.pageX - $(this).offset().left; //mx = mouse x position with some adjustment relateive to left of box

      if (event.pageX < 460) {
        $(selector).css({//set the selected popup box coordinates near the mouse as the mouse moves
          "left": mr,
          "top": my,
        });
      }
      if (event.pageX > 460){
        $(selector).css({//set the selected popup box coordinates near the mouse as the mouse moves
          "left": mx,
          "top": my,
        });
      }

    });
  }
  $(".popup").hide();
  $(".popup").removeClass('hidden');
  if (window.innerWidth > 768){
    var boxHovered, boxNumber, selector, targetedBox, adjustX, adjustY;
   // $(".popup").hide();//This hides all the pop-ups when page loads
    $(".box").hover(function () {//This executes when you hover ON the box
      boxHovered = $(this).attr("id");//Gets the id of the box such as "box1", "box2"
      targetedBox = "#" + boxHovered;//creates a value of "#box1", "#box2", etc for future use
      boxNumber = boxHovered.substr(3, 5);//extracts the # from the id, such as 1, 2, 3
      selector = "#popup" + boxNumber;//creates a value of "#popup1", "#popup2", etc for future use
      $(selector).show();//This reveals the popup inside the hovered box
      moveBox();//This calls on the function below to execute
    }, function () {//This executes when you hover OFF the box
      $(selector).hide();//This hides the popup inside the hovered box
    });

  }

});

var menu = document.getElementById('menu-phone');
var nav = document.getElementById('nav-phone');
if(menu) {
  menu.addEventListener('click', function () {
    if(nav) {
      nav.classList.toggle('-translate-y-full');

    }
  })
}
